// extracted by mini-css-extract-plugin
export default {"summaryContainer":"Summary_summaryContainer__mkC3k","listContainer":"Summary_listContainer__bNweU","list":"Summary_list__pzJeD","summaryButtons":"Summary_summaryButtons__Kq1NC"};